export enum SlideControl {
  MOVE_LEFT,
  MOVE_RIGHT,
  DELETE
}